import React from "react";
import "./error-server.scss";
import { useDispatch, useSelector } from "react-redux";
import { messageError } from "../../store/actions";
import DialogTitle from "../modal-components/dialog-title";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { DialogContent } from "@material-ui/core";

const ErrorServer = () => {
  const error = useSelector((state) => state.admin.errorMessage);
  const dispatch = useDispatch();
  const closeError = () => {
    dispatch(messageError(null));
  };
  return (
    <Dialog
      open={error !== null}
      onClose={closeError}
      aria-labelledby="form-dialog"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="formDialogServerError">Ошибка</DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "center" }}>{error}</div>
      </DialogContent>
      <DialogActions id="serverErrorActions">
        <Button
          onClick={closeError}
          color="primary"
          variant="contained"
          style={{ margin: "20px auto" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorServer;
